// uses ./appsListFilter.less
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';

import { updateFilter } from './appsListFiltersActionCreators';
import t from '../../../translations';

const filtersTranslations = t.filters;

function AppsListFilter(props) {
    const [isExpanded, toggleExpanded] = useState(props.initialExpanded);

    if (props.unifiedPlatform) {
        Object.assign(filtersTranslations, filtersTranslations.unifiedPlatform);
    }

    return (
        <div className="appsListFilter">
            <h4
                className="appsListFilter-title"
                onClick={() => toggleExpanded((isExpanded) => !isExpanded)}
                {...(props.name === 'industries' ? { 'data-pendoid': 'allapps&IntegrationFilters-Industries' } : {})}
            >
                {filtersTranslations[props.name]}
                <i className={`zmdi zmdi-chevron-${isExpanded ? 'up' : 'down'}`} />
            </h4>
            <div className="filters-wrapper" hidden={!isExpanded}>
                {Object.keys(props.filters).map((filterName) => (
                    <div key={filterName}>
                        <input
                            type="checkbox"
                            id={filterName}
                            name={filterName}
                            checked={props.filters[filterName]}
                            onChange={props.dispatchUpdateFilter}
                        />
                        <label
                            className="appsListFilter-label"
                            htmlFor={filterName}
                            data-tooltip={t.filtersTooltips[filterName]}
                        >
                            {filtersTranslations[filterName]}
                        </label>
                    </div>
                ))}
            </div>
        </div>
    );
}

AppsListFilter.propTypes = {
    name: PropTypes.string.isRequired,
    filters: PropTypes.object.isRequired,
    unifiedPlatform: PropTypes.bool.isRequired,
    dispatchUpdateFilter: PropTypes.func.isRequired,
    initialExpanded: PropTypes.bool.isRequired,
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    dispatchUpdateFilter: (e) => dispatch(updateFilter(ownProps.name, e.currentTarget.name, e.currentTarget.checked)),
});

export default connect(null, mapDispatchToProps)(AppsListFilter);
